import ApiClient from './ApiClient';

class TarefasAPI extends ApiClient {
  constructor() {
    super('tarefas', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  toggleStatus(id) {
    return axios.patch(`${this.url}/${id}/toggle_status`);
  }

  getSummary() {
    return axios.get(`${this.url}/summary`);
  }

  searchContacts(q) {
    return axios.get(`${this.url}/search_contacts`, { params: { q } });
  }
}

export default new TarefasAPI();
